Vue.component('autocomplete', {
    props: {   
        dataset: {
            type: String
        },
        search: {
            type: Object
        },
        skipupdatesearch: {
            type: Boolean,
            default: false
        },
        updates: {
            type: Number
        },
        isLoadingTable: {
            type: Boolean
        },
        field: {
            type: String,            
        },
        fieldtitle: {
            type: String
        },  
        async: {
            type: Boolean,
            required: false,
            default: false,
        },
        isProfile: {
            type: Boolean,
            required: false,
            default: false
        },
        items: {
            type: Array,
            required: false,
            default: () => {}
        },
        onselect: {
            type: Object,
            required: false,
            default: () => {}
        },
        resultstring: {
            type: String
        },
        selectedkey: {
            type: String
        },
        searchfield: {
            type: String
        },
        selectedgroup: {
            type: String
        },
        selectedData: {
            type: Object
        },
        includeMap: {
            type: Boolean
        },
        showinput: {
            type: Boolean
        },
        selectedmax: {
            type: Number,
            default: -1
        },
    },
    data () {
        return {
            id: this.makeid(),
            input: '',
            selected: [],
            isOpen: false,
            results: [],
            data: [],
            isLoading: false,
            arrowCounter: -1,
            tableRows: null,
            id: 'autocomplete_' + this.makeid(),

            
        }
    },
    computed: {
        placeholder () {
            if (this.isLoading) {
                return 'loading data...'
            }
            if (this.selectedmax > 0 && this.results.length == this.selectedmax) {
                return 'Maximum Selected Reached';
            }
            return '';
        },
        isDisabled () {
            if (this.isLoading || (this.selectedmax > 0 && this.selected.length == this.selectedmax)) {
                return true;
            }
            return false;
        },
        hasSelected () {
           return this.selected.length > 0
        },
        noentries () {
           if (this.results.length == 0) {
               return 'No results found for "' + this.input + '"';
           }
           return false;
        } 
    },
    created () {
        if (this.async) {
            this.isLoading = true;
        }
        this.addListeners();
    },
    async mounted () {                 
        if (this.async) {                    
            this.$emit('isloading', this.id)    
            let obj = new FormData;
            obj.append('action', 'slide_get_data');
            obj.append('field', this.field)
            
            // CHECK LOCAL STORAGE FOR APPROPRIATE FIELDS
            let data = {};
            if (this.field == "nces_id") {                
                newdata = slideGetStorage(this.field);
                if (newdata) {
                    data.data = newdata; 
                }
                else {
                    data = await axios.post(axios_ajax.ajaxurl, obj);
                    slideSetStorage(this.field, data.data)
                }                
            } else {                
                data = await axios.post(axios_ajax.ajaxurl, obj);
            }            
            this.data = data.data;
            this.isLoading = false;
            this.$emit('isloaded', this.id)
            bus.$emit('autocompleteisloaded', this.id)
            if (this.field == "nces_id") {
                this.$emit('districtdataloaded', this.data)                
            }
            
        }
        else {
            this.isLoading = false;
            this.data = this.items;
        }
    },
    methods: {
        makeid () {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < 10; i++) {
              text += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            return text;
        },
        timeout(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        onChange () {
            if (this.input.length > 2) {
                this.results = this.data.filter(e => e[this.searchfield].toLowerCase().indexOf(this.input.toLowerCase()) > -1);                 
                this.isOpen = true;                
            }
        }, 
        select (result) {
            this.selected.push(result)
            this.isOpen = false;
            this.input = '';
            let filtervalues = {
                field: this.field,
                selected: this.selected,
                key: this.selectedkey
            }
            if (!this.skipupdatesearch) {                
                this.$emit('updatesearch', this.selectedgroup, filtervalues);   
                bus.$emit('tutorialListener', 'updatesearch')
                bus.$emit('tutorialListener', 'updatesearchfinished')
            }
            
            
            this.$refs.input.focus();

            if (this.onselect && this.onselect.function && this[this.onselect.function]) {
                let params = {};
                if (this.onselect.params) {
                    for (const key in this.onselect.params) {
                        let param = this.onselect.params[key];
                        switch (param.type) {
                            case 'singledistrict':
                                bus.$emit('tutorialListener', 'singledistrictloading')
                                params[key] = this.selected[0].nces_id
                                break;
                            case 'otherdistrict':
                                params[key] = this.selected[this.selected.length - 1].nces_id
                                break;
                            default: 
                                params[key] = this.onselect.params[key].value;
                                break;
                        }
                    }
                }
                this[this.onselect.function](params);
            }
        },
        getResultDisplay (result) {
            let string = this.resultstring;
            if (string == 'result') {return result;}
            let regexp = /\[(.*?)\]/g;
            let matches = [...this.resultstring.matchAll(regexp)];               
            for (const match of matches) {             
                string = string.replace(match[0], result[match[1]]);                
            }            
            return string;
        },
        remove (i) {      
            
            if (this.isProfile) {
                this.$emit('resetprofile');
            }
            this.selected.splice(i, 1);
            let filtervalues = {
                field: this.field,
                selected: this.selected,
                key: this.selectedkey
            }            
            this.$emit('updatesearch', this.selectedgroup, filtervalues);
        },
        removeAll () {
            for (let i = this.selected.length - 1; i >= 0; i--) {
                this.remove(i);
            }
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onEnter() {
            this.select(this.results[this.arrowCounter]);            
            this.isOpen = false;
            this.arrowCounter = -1;

        },
        updatesearch (st, add) {            
            if (add) {
                this.select(st)
            } else {
                //GET LOCATION TO REMOVE - LIMITED TO STATES RIGHT NOW
                let i = false;
                for (let j = 0; j < Object.keys(this.selected).length; j++) {
                    if (this.selected[j].abbr == st.abbr) {                        
                        i = j;
                    }
                }
                this.remove(i);
            }            
        },
        async getSingleDistrictData (p) {
            
            if (this.isProfile) {
                this.$emit('getprofiledistrictdata', p)
            }
            
        },
        addPeer (p) {   
            bus.$emit('addPeer', p.nces_id)
            bus.$emit('toast', {text: 'Peer Added'})
        },
        addListeners () {
            let $this = this;
            if (this.field == "STATE") {
                bus.$on('updateSavedStates', function(obj) {
                    for (const st of obj) {
                        let o = {}                        
                        o.STATE = st;
                        let statetoabb = slideStateToAbbr();
                        o.abbr = statetoabb[slideTitleCase(st)];
                        $this.updatesearch(o, true);                        
                    }
                })    
            }
            if (this.field == "nces_id" && !this.isProfile) {
                
                bus.$on('updateSavedDistricts', function(obj) {
                    for (const nces of obj) {
                        let d = Object.keys($this.data).find(key => $this.data[key].nces_id === nces);
                        
                        $this.updatesearch($this.data[d], true)                       
                    }
                })
                bus.$on('addPeers', function(peers) {
                    this.skipupdatesearch = true;
                    peers.forEach((peer) => {
                        $this.select(peer);
                        
                    });
                    this.skipupdatesearch = false;
                    bus.$emit('peersAdded', peers);
                });
            }
            
        },
    }
  })